import { inject, observer } from 'mobx-react'
import React from 'react'
import styled from 'styled-components';
import { RouteComponentProps } from 'react-router'
import { withStateCard, TutorialButtonAndBackButton, Toast, ToastType } from '../../Components';
import DetalhesProfessorCard from './Components/DetalhesProfessorCard'
import { ProfessorStore, PROFESSOR_STORE } from '../../Store'
import Tutorial_Funcionario from "../../Utils/Tutorial/Manual_do_portal_do_TCC_Funcionario.pdf";

interface IProps extends RouteComponentProps<{ id: string }> {
    [PROFESSOR_STORE]: ProfessorStore;
}

const StyledText = styled.span`
  padding: 5px;
`;

const Container: React.FC = (props: React.HTMLAttributes<HTMLDivElement>) => <>{props.children}</>;
const DetalhesProfessorPageWithState = withStateCard(Container);

@inject(PROFESSOR_STORE)
@observer
export default class DetalhesProfessorPage extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);
    }

    componentDidMount() {
        const id = Number(this.props.match.params.id);
        const store = this.props[PROFESSOR_STORE];
        store.getProfessorComSuasMonografiasEPreProjetos(id);
        store.getAlunosAtivos();
    }

    onResumeClick = () => {
        window.open(Tutorial_Funcionario);
    }

    alterarVagasPreProjeto = async (id:number, vagasPreProjeto:number) => {
        const professorStore = this.props[PROFESSOR_STORE];
        await professorStore.alterarVagasPreProjeto(id,vagasPreProjeto);
        window.location.reload();
    }

    inserirMonografia = async (alunoId:number, professorId: number, titulo:string) => {
        const professorStore = this.props[PROFESSOR_STORE];
        await professorStore.inserirMonografia(alunoId,professorId,titulo);
        window.location.reload();
    }

    ativarDesativar = async () => {
        const professorStore = this.props[PROFESSOR_STORE];
        await professorStore.ativarDesativarUmProfessor();
    }

    ativarDesativarMembroBanca = async () => {
        const professorStore = this.props[PROFESSOR_STORE];
        await professorStore.ativarDesativarUmProfessorComoMembroBanca();
    }

    render() {
        const professorStore = this.props[PROFESSOR_STORE]
        const { professor, professoresState, alunosAtivos } = professorStore;
        const { history } = this.props;

        return (
            <DetalhesProfessorPageWithState
                state={professoresState}
                loading='Carregando...'
            >
                <TutorialButtonAndBackButton
                    openTutorial={this.onResumeClick}
                    voltar={() => history.push('/funcionario')}
                />
                {professor && !professor.professor.ativo &&
                    <Toast type={ToastType.error}>
                        <StyledText>
                            PROFESSOR DESATIVADO.
                        </StyledText>
                    </Toast>}
                {professor && !professor.professor.ativoBanca &&
                    <Toast type={ToastType.error}>
                        <StyledText>
                            PROFESSOR DESATIVADO COMO MEMBRO.
                        </StyledText>
                    </Toast>}  
                <DetalhesProfessorCard professor={professor} 
                alterarVagasPreProjeto={this.alterarVagasPreProjeto}
                ativarOuDesativar={this.ativarDesativar} 
                ativarOuDesativarMembroBanca={this.ativarDesativarMembroBanca} 
                onInserirMonografia={this.inserirMonografia}
                alunosAtivos={alunosAtivos}
                />  
            </DetalhesProfessorPageWithState>
        )
    }
}